﻿import isPromiseAlike from "./isPromiseAlike";

export default async function runSyncAsync<T>(fn: () => T | Promise<T>): Promise<T> {
	const awaitable = fn();
	if (isPromiseAlike(awaitable)) {
		return await awaitable;
	}

	return awaitable;
}
